import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AllStatusListController from '../Controllers/AllStatusListController';
import DateInput from '../../Components/DateInput';
import Input from '../../Components/Input';
import downArrow from '../../Assets/Icons/chevron-down.png';
import filter from '../../Assets/Icons/filter.png';
import Loader from '../../Components/Loader';
import Dropdown from '../../Components/Dropdown';
import { convertGMTToLocal } from '../../Utils/Validation';
import AddExpenseModal from '../Components/AddExpenseModal';
import ApproveDisbursementModal from '../Components/ApproveDisbursementModal';

const AllStatusListScreen = () => {
    const location = useLocation();
    const title = location?.state?.title;
    const isDisbursement = title === 'Disbursement wise Reports';
    const reportKey = location?.state?.report_key || '';
    const heading = location?.state?.heading || 'Expense Report';
    const actionType = location?.state?.action_type || 'expense_report';
    const selectedYear = location?.state?.selectedYear;

    const {
        expenses,
        filters,
        showFilters,
        toggleFilters,
        handleFilterChange,
        resetFilters,
        cancelFilters,
        applyFilters,
        loading,
        error,
        currentPage,
        totalPages,
        handlePageChange,
        visiblePages,
        statusListError,
        showModal,
        openModal,
        closeModal,
        handleViewService,
        expenseInfoRef,
        handleApproveReject,
        userLoading,
        userError,
        userOptions,
        handleDisApproveReject,
        showDisModal,
        fetchStatusList,
    } = AllStatusListController(actionType, selectedYear);

    const [openDropdown, setOpenDropdown] = useState(null);
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const dropdownRefs = useRef({});

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const isRejected = reportKey === "rejected_completely" || reportKey === "rejected_partially";

    const tableHeaders = isDisbursement
        ? [actionType === "rejected_disbursement" ? "Rejected Date" : "Approved Date", "Applied On",]
            .concat(actionType === "rejected_disbursement" ? "Reject Reason" : [])
            .concat(["Requested Amount",
                actionType === "rejected_disbursement" ? "Rejected Amount" : "Approved Amount",
                actionType === "rejected_disbursement" ? "Rejected By" : "Approved By"
            ])
            .concat(actionType === "pending_disbursement" ? "" : [])
        : [isRejected ? "Rejected Date & Time" : "Approved Date & Time", "Applied On", "Amount Applied",]
            .concat(isRejected ? ["Amount Rejected"] : ["Amount Approved"])
            .concat(reportKey !== 'pending_expenses' ? isRejected ? ["Rejected By"] : ["Approved By"] : [])
            .concat([""]);

    return (
        <div className="tasksScreen-main-content">
            <div className="title-container" style={{ paddingBottom: 20 }}>
                <h2 className="title">{isDisbursement ? 'Disbursement Wise Report' : 'Expense Wise Report'}</h2>
            </div>
            <div className="tasksScreen-tasks-container">
                <div className="tasksScreen-tasks-header" style={{ paddingBottom: 10 }}>
                    <h2 className="tasksScreen-tasks-title" style={{ fontSize: '18px', fontWeight: 500 }}>
                        {heading}
                    </h2>
                </div>

                <div className="tasksScreen-filters-row" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
                    <div className="tasksScreen-filters-button-wrapper">
                        <button className="tasksScreen-filters-button" onClick={toggleFilters}>
                            <img src={filter} alt="Filter" style={{ width: 12 }} /> Filters
                        </button>
                    </div>
                </div>

                {showFilters && (
                    <div className="tasksScreen-filters-container tasksScreen-open-filters">
                        <div className="tasksScreen-filters">
                            <div>
                                <label style={{ fontSize: '12px', color: '#343C44' }}>{(actionType === 'rejected_disbursement' || isRejected) ? 'Rejected Date' : (actionType === 'pending_disbursement' || reportKey === 'pending_expenses') ? 'Applied Date' : 'Approved Date'
                                }</label>
                                <DateInput
                                    label="Approved Date"
                                    value={filters.approved_date}
                                    onChange={(e) => handleFilterChange('approved_date', e.target.value)}
                                />
                            </div>
                            <div>
                                <label style={{ fontSize: '12px', color: '#343C44' }}>Expense Date</label>
                                <DateInput
                                    label="Expense Date"
                                    value={filters.expense_date}
                                    onChange={(e) => handleFilterChange('expense_date', e.target.value)}
                                />
                            </div>
                            <Input
                                label={
                                    (reportKey === 'approved_expenses' || actionType === 'approved_disbursement') ? "Approved Amount" :
                                        reportKey === 'pending_expenses' ? "Applied Amount" :
                                            actionType === 'pending_disbursement' ? "Requested Amount" :
                                                (reportKey === 'rejected_partially' || reportKey === 'rejected_completely' || actionType === 'rejected_disbursement') ? "Rejected Amount" :
                                                    ""
                                }
                                inputType="number"
                                placeholder="Enter amount"
                                value={filters.amount}
                                onChange={(e) => handleFilterChange('amount', e.target.value)}
                            />
                            {reportKey !== 'pending_expenses' && (
                                <Dropdown
                                    ref={(el) => (dropdownRefs.current["ApprovedBy"] = el)}
                                    isOpen={openDropdown === "ApprovedBy"}
                                    toggleDropdown={() => toggleDropdown("ApprovedBy")}
                                    label={(actionType === 'rejected_disbursement' || isRejected) ? 'Rejected By' : 'Approved By'}
                                    options={userOptions || []}
                                    placeholder="------"
                                    value={filters?.approved_by}
                                    onChange={(value) => handleFilterChange('approved_by', value?.value)}
                                    loading={userLoading}
                                    errorMessage={userError}
                                />
                            )}
                        </div>
                        <div>
                            {error && <div className='list-error-msg' style={{ textAlign: 'left', paddingBottom: 5 }}> {error} </div>}
                            <div className="tasksScreen-filter-buttons">
                                <button onClick={applyFilters} className="tasksScreen-apply-button" 
                                style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.5 : 1 }} disabled={loading} >Apply</button>
                                <button onClick={cancelFilters} className="tasksScreen-cancel-button">Cancel</button>
                                <button onClick={resetFilters} className="tasksScreen-reset-button">Reset</button>
                            </div>
                        </div>
                    </div>
                )}

                <div className="tasksScreen-task-table-wrapper">
                    <table className="tasksScreen-task-table">
                        <thead>
                            <tr>
                                {tableHeaders.map((header, idx) => (
                                    <th key={idx}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        {expenses.length > 0 && (
                            <tbody style={{ backgroundColor: "white" }}>
                                {expenses.map((exp, idx) => (
                                    <tr key={idx}>
                                        {isDisbursement ? (
                                            <>
                                                <td>{convertGMTToLocal(exp?.dis_approved_at, "dd/MM/yyyy, hh:mm A") || '--'}</td>
                                                <td>{convertGMTToLocal(exp?.dis_applied_at, "dd/MM/yyyy") || '--'}</td>
                                                {actionType === "rejected_disbursement" && <td>{exp?.reject_reason || '--'}</td>}
                                                <td>{exp?.dis_request_amt}</td>
                                                <td>{actionType === "rejected_disbursement" ? exp?.dis_request_amt : actionType === "pending_disbursement" ? '--' : exp?.dis_approve_amt}</td>
                                                <td>{exp?.approved_by || '--'}</td>
                                                {actionType === "pending_disbursement" && (
                                                    <td>
                                                        <span
                                                            style={{ color: "#5A55D2", textDecoration: "underline", cursor: "pointer" }}
                                                            onClick={() => handleDisApproveReject(exp)}
                                                        >
                                                            Approve/Reject
                                                        </span>
                                                    </td>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <td>{convertGMTToLocal(exp?.approved_date, "dd/MM/yyyy, hh:mm A") || '--'}</td>
                                                <td>{convertGMTToLocal(exp?.created_at, "dd/MM/yyyy") || '--'}</td>
                                                <td>{exp?.amount}</td>
                                                <td>{reportKey === 'rejected_completely' ? exp?.amount : reportKey === "pending_expenses" ? '--' : reportKey === "rejected_partially" ? exp?.amount - exp?.approved_amount : exp?.approved_amount}</td>
                                                {reportKey !== 'pending_expenses' && (
                                                    <td>{exp?.approved_by_name || '--'}</td>
                                                )}
                                                {reportKey !== 'pending_expenses' ? (
                                                    <td style={{ color: '#5A55D2', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => { handleViewService(exp) }}>View details</td>
                                                ) : (
                                                    <td>
                                                        <span
                                                            style={{ color: "#5A55D2", textDecoration: "underline", cursor: "pointer" }}
                                                            onClick={() => handleApproveReject(exp)}
                                                        >
                                                            Approve/Reject
                                                        </span>
                                                    </td>
                                                )}
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>
                    {!loading && statusListError && <div className="list-error-msg">{statusListError}</div>}
                    {loading && <Loader loading={loading} color="var(--primary-loader-color)" />}
                </div>

                <div className="tasksScreen-table-footer">
                    <span className="tasksScreen-pagination-info">{`${currentPage}-${totalPages} of items`}</span>
                    <div className="tasksScreen-pagination">
                        <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                            <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image" />
                        </button>
                        {visiblePages.map((page) => (
                            <button key={page} className={`tasksScreen-pagination-button ${currentPage === page ? 'active' : ''}`} onClick={() => handlePageChange(page)}>
                                {page}
                            </button>
                        ))}
                        <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                            <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image" />
                        </button>
                    </div>
                </div>
                {showModal && <AddExpenseModal isOpen={showModal} onClose={closeModal} editData={expenseInfoRef.current} onValueChange={fetchStatusList} />}
                {showDisModal && <ApproveDisbursementModal isOpen={showDisModal} onClose={closeModal} editData={expenseInfoRef.current} page='disApproval' onValueChange={fetchStatusList} />}
            </div>
        </div>
    );
};

export default AllStatusListScreen;
